import React from 'react';
import { STORAGE_URL } from '~/constants';

const UserInfoSection = ({ user, empresa }) => {
  const urlLogo = `${STORAGE_URL}logo/${empresa?.imagemLogo}`;

  return (
      <div className={`scrollable`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 'calc(var(--horizontal-item-grid-spacing)*2)', overflowX: 'auto', padding: 'var(--spacing-size)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 'var(--half-spacing-size)' }}>
          <div style={{ width: 'var(--url-logo-size)', height: 'var(--url-logo-size)' }}>
            {urlLogo && <img style={{ width: 'var(--url-logo-size)', height: 'var(--url-logo-size)' }} src={urlLogo} alt="logo" />}
          </div>
          <div style={{ gap: 'var(--vertical-item-grid-spacing)', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
            <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
              {empresa.razaoSocial}
            </span>
            <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
              {empresa.enderecoLogradouro}, {empresa.enderecoLogradouroNumero}, {empresa.enderecoIntCidade} / {empresa.uf}
            </span>
            <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
              {empresa.cnpj}
            </span>
          </div>
        </div>
        <div style={{ fontSize: 'var(--regular-text-size)', borderTop: 'none', display: 'grid', gridTemplateColumns: 'auto auto', rowGap: 'var(--vertical-item-grid-spacing)', columnGap: 'calc(var(--horizontal-item-grid-spacing)*2)' }}>
          <strong style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
            Usuário:
          </strong>
          <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
            {user.nome}
          </span>
          <strong style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
            Data/Hora:
          </strong>
          <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
            {new Date().toLocaleString('pt-BR')}
          </span>
        </div>
      </div>
  );
};

export default UserInfoSection;
